<template>
  <Pagos />
</template>

<script>
import Pagos from '@/components/Pagos/Pagos.vue'
export default {
  name: 'PagosView',
  components: { Pagos }
}
</script>



// WEBPACK FOOTER //
// src/views/socios/PagosView.vue